import { Skeleton } from '@material-ui/lab';
import type { PublicRoadmapData } from '@mogul/api-client';
import React, { useEffect, useState } from 'react';

import styles from './Roadmap.module.css';
import { TimelineComponent } from './Timeline.component';

export interface Props {
  roadmapData: PublicRoadmapData[];
}

export const RoadMap: React.FC<Props> = props => {
  const [isLastRoadmapEven, setIsLastRoadmapEven] = useState(false);

  useEffect(() => {
    if (props.roadmapData.length > 0 && props.roadmapData.length % 2 === 0) {
      setIsLastRoadmapEven(true);
    }
  }, [props.roadmapData.length]);

  return (
    <div className={'pb-20 mb-5'}>
      <h1 className={`${styles.roadmapHeader} sm:mx-0 mx-10 pb-14`}>ROADMAP</h1>
      {props.roadmapData.length ? (
        <div className={'flex flex-col justify-start items-center'}>
          <div className={styles.firstTimeline}>
            {props.roadmapData.length > 0 ? (
              <div
                className={styles.roadmapContent}
                style={{ flexDirection: 'row' }}
              >
                <div className={styles.innerContent}>
                  <div className={'text-lg font-semibold'}>
                    {props.roadmapData[0].title}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className={styles.timelineContainer}>
            {props.roadmapData.length > 0
              ? props.roadmapData.map((entry, index) => {
                  return (
                    <TimelineComponent
                      roadmap={entry}
                      length={props.roadmapData.length - 1}
                      key={index}
                      index={index}
                    />
                  );
                })
              : null}
          </div>
          <div className={styles.lastTimeline}>
            {props.roadmapData.length > 0 ? (
              <div
                className={styles.roadmapContent}
                style={
                  isLastRoadmapEven
                    ? { flexDirection: 'row-reverse', textAlign: 'right' }
                    : { flexDirection: 'row' }
                }
              >
                <div className={styles.innerContent}>
                  <div className={'font-semibold mb-1'}>
                    {props.roadmapData[props.roadmapData.length - 1].label}
                  </div>
                  <span className="text-sm">
                    {
                      props.roadmapData[props.roadmapData.length - 1]
                        .description
                    }
                  </span>
                </div>
                <div className={styles.imageContainer}>
                  <img
                    src={props.roadmapData[
                      props.roadmapData.length - 1
                    ].image?.publicUrl.replace(
                      'd8r7g9tzupsfa',
                      'd2bhvhyqzg9zio',
                    )}
                    className={styles.image}
                    alt=""
                    style={
                      isLastRoadmapEven ? { float: 'left' } : { float: 'right' }
                    }
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="w-full">
          <Skeleton height={600}></Skeleton>
        </div>
      )}
    </div>
  );
};
